import React from "react";

export function TravelBeachIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="travel-places-beach--island-waves-outdoor-recreation-tree-beach-palm-wave-water--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M27 26.96H26C24.9391 26.96 23.9217 26.5385 23.1716 25.7884C22.4214 25.0382 22 24.0208 22 22.96C22 24.0208 21.5786 25.0382 20.8284 25.7884C20.0783 26.5385 19.0609 26.96 18 26.96C16.9391 26.96 15.9217 26.5385 15.1716 25.7884C14.4214 25.0382 14 24.0208 14 22.96C14 24.0208 13.5786 25.0382 12.8284 25.7884C12.0783 26.5385 11.0609 26.96 10 26.96C8.93913 26.96 7.92172 26.5385 7.17157 25.7884C6.42143 25.0382 6 24.0208 6 22.96C6 24.0208 5.57857 25.0382 4.82843 25.7884C4.07828 26.5385 3.06087 26.96 2 26.96H1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M20 18.96C18.97 17.7077 17.6754 16.6991 16.2091 16.0066C14.7429 15.3141 13.1416 14.955 11.52 14.955C9.89853 14.955 8.29714 15.3141 6.83094 16.0066C5.36473 16.6991 4.07009 17.7077 3.04004 18.96"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M13 15.0599C13.12 10.5399 14.5 6.41994 17.5 4.93994"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <g id="Group_2">
            <path
              id="Vector_4"
              d="M11.52 1.13996C12.8165 0.884673 14.1615 1.13648 15.2778 1.84347C16.3941 2.55047 17.1966 3.65878 17.52 4.93996"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              vectorEffect={vectorEffect}
            />
            <path
              id="Vector_5"
              d="M24.82 5.67992C23.8995 4.68597 22.6478 4.06229 21.2999 3.92603C19.952 3.78978 18.6008 4.15031 17.5 4.93992"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              vectorEffect={vectorEffect}
            />
            <path
              id="Vector_6"
              d="M10.1602 7.07991C10.9439 5.92532 12.1055 5.08 13.4452 4.68941C14.7848 4.29883 16.2187 4.38741 17.5002 4.93991C18.7855 5.25426 19.8983 6.05586 20.6036 7.17542C21.309 8.29497 21.5515 9.64483 21.2802 10.9399"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              vectorEffect={vectorEffect}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
